import emitter from 'meinian-package/src/utils/emitter'
import { useLayoutEffect, useState } from 'react'

export default class ForceGuide { // 页面强制引导类
  constructor(sendKey) {
    this.sendKey = sendKey
  }

  sendKey = null

  domArr = new Map([])

  useOn(callback) {
    const [dep, setDep] = useState({})
    useLayoutEffect(() => {
      const onResize = () => {
        const position = []
        const values = this.domArr.size > 1
          ? Array.from(this.domArr).sort((a:any, b:any) => a[0] - b[0]).map(item => item[1]) : Array.from(this.domArr).map(item => item[1])
        values.forEach((item:any) => {
          const temp = item.getBoundingClientRect()
          position.push(temp)
        })
        callback(position)
      }
      emitter.on(this.sendKey, () => {
        setDep({})
        onResize()
      })
      window.addEventListener('resize', onResize)
      return () => {
        window.removeEventListener('resize', onResize)
        emitter.off(this.sendKey)
      }
    }, [JSON.stringify(dep)])
  }

  useEmit(key, dom, dep?:any) { // 把需要引导的dom进行注册
    useLayoutEffect(() => {
      this.domArr.set(key, dom.current)
      emitter.emit(this.sendKey, this.domArr)
    }, [dom.current, dep])
  }
}
